import { render, staticRenderFns } from "./HighlightsSection.vue?vue&type=template&id=77f04682&scoped=true"
import script from "./HighlightsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightsSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f04682",
  null
  
)

export default component.exports